"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var AvatarGroup_1 = __importDefault(require("atomicComponents/atoms/Avatar/AvatarGroup"));
var LogoImg_1 = __importDefault(require("atomicComponents/atoms/Logo/LogoImg"));
var CloseButton_1 = __importDefault(require("components/Buttons/CloseButton"));
var Money_1 = __importDefault(require("components/Money"));
var OptimiseButtons_1 = __importDefault(require("../OptimiseButtons"));
var SpendAndPricingPlansBadges_1 = __importDefault(require("../Parts/SpendAndPricingPlansBadges"));
var PREFIX = 'ForexCosts';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    descriptionHeadingContainer: "".concat(PREFIX, "-descriptionHeadingContainer"),
    descriptionHeading: "".concat(PREFIX, "-descriptionHeading"),
    topFeaturesContainer: "".concat(PREFIX, "-topFeaturesContainer"),
    serviceStatAttributeLabel: "".concat(PREFIX, "-serviceStatAttributeLabel"),
    serviceStatAttributeContainer: "".concat(PREFIX, "-serviceStatAttributeContainer"),
    rightAttributeContainer: "".concat(PREFIX, "-rightAttributeContainer"),
    isOpen: "".concat(PREFIX, "-isOpen"),
    servicesLogos: "".concat(PREFIX, "-servicesLogos"),
    greenText: "".concat(PREFIX, "-greenText"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            width: 'calc(100% - 28px)',
            marginLeft: 8,
        },
        _b[".".concat(classes.descriptionHeadingContainer)] = {
            color: 'hsl(0,0%,30%)',
            fontWeight: 500,
            letterSpacing: '.0023em',
            lineHeight: '32px',
        },
        _b[".".concat(classes.descriptionHeading)] = {
            color: theme.palette.primary.main,
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        _b[".".concat(classes.topFeaturesContainer)] = {
            marginLeft: '24px',
            height: '24px',
        },
        _b[".".concat(classes.serviceStatAttributeLabel)] = {
            width: '140px',
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.serviceStatAttributeContainer)] = {
            display: 'flex',
            fontSize: '1rem',
            color: theme.palette.primary.main,
            fontWeight: 500,
            marginTop: '8px',
            marginBottom: '8px',
        },
        _b[".".concat(classes.rightAttributeContainer)] = {
            marginLeft: 'auto',
            marginRight: '20px',
        },
        _b[".".concat(classes.isOpen)] = {
            width: 756,
            paddingTop: 32,
        },
        _b[".".concat(classes.servicesLogos)] = {
            '& div:first-of-type': {
                // logos use .MuiAvatar-circular, badges use circle
                zIndex: 9,
                color: theme.palette.grey[600],
                fontWeight: theme.typography.fontWeightMedium,
                marginLeft: theme.spacing(-0.5),
                backgroundColor: theme.palette.common.white,
                boxShadow: '0 1px 2px 0.5px rgb(255 159 191 / 80%)',
            },
        },
        _b[".".concat(classes.greenText)] = {
            color: (_c = theme.palette.green) === null || _c === void 0 ? void 0 : _c.main,
        },
        _b);
});
var ForexCosts = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var recommendation = _a.recommendation, serviceStat = _a.serviceStat, onClickClose = _a.onClickClose;
    var service = serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.service;
    var appsCount = ((_b = recommendation.multiServiceMeta) === null || _b === void 0 ? void 0 : _b.appsSaving) ? Object.keys((_c = recommendation.multiServiceMeta) === null || _c === void 0 ? void 0 : _c.appsSaving).length : 0;
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "fs-md lh-3 d-flex color-primary justify-content-between" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Forex costs" }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { closeAction: onClickClose })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "my-6 ds-avatar__name fs-md" }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.descriptionHeadingContainer }, { children: ["You are paying ", (0, jsx_runtime_1.jsx)("span", __assign({ className: "color-red" }, { children: "very high" })), " forex costs for", service
                            ? " ".concat(service.name, " ").concat(appsCount > 1 && " and ".concat(appsCount - 1, " other app").concat(appsCount > 2 ? 's' : ''))
                            : " ".concat(appsCount, " apps"), (0, jsx_runtime_1.jsx)(AvatarGroup_1.default, __assign({ max: 9, className: ((_d = recommendation.multiServiceMeta) === null || _d === void 0 ? void 0 : _d.appLogos) && ((_e = recommendation.multiServiceMeta) === null || _e === void 0 ? void 0 : _e.appLogos.length) > 9
                                ? classes.servicesLogos
                                : '' }, { children: (_f = recommendation.multiServiceMeta) === null || _f === void 0 ? void 0 : _f.appLogos.map(function (logo) { return (0, jsx_runtime_1.jsx)(LogoImg_1.default, { src: logo }, logo); }) })), ". You can switch to virtual credit cards in foreign currencies and cut", ' ', (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.greenText }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: recommendation.potentialSavings }), " / yr"] })), "of your annual spend."] })) })), serviceStat && (0, jsx_runtime_1.jsx)(SpendAndPricingPlansBadges_1.default, { serviceStat: serviceStat }), service && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('d-flex', classes.descriptionHeadingContainer) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.serviceStatAttributeContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.serviceStatAttributeLabel }, { children: ["Forex costs (", service.name, ")"] })), (0, jsx_runtime_1.jsx)(Money_1.default, { amount: (_g = recommendation.multiServiceMeta) === null || _g === void 0 ? void 0 : _g.appsSaving[serviceStat.id] }), " / yr"] })) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('d-flex', classes.descriptionHeadingContainer) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.serviceStatAttributeContainer }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.serviceStatAttributeLabel }, { children: "Total Spend" })), (0, jsx_runtime_1.jsx)(Money_1.default, { amount: (recommendation.potentialSavings || 0) * 33.3333 }), " / yr (", appsCount, " tools)"] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('d-flex', classes.descriptionHeadingContainer) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.serviceStatAttributeContainer }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.serviceStatAttributeLabel }, { children: "Savings" })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.greenText }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: recommendation.potentialSavings }), " / yr"] }))] })) })), (0, jsx_runtime_1.jsx)(OptimiseButtons_1.default, __assign({ activateText: "Access Offer" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "my-6 ds-avatar__name fs-base" }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.descriptionHeadingContainer }, { children: ["Activation Link: ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "http://airwallex.com/hudled" }, { children: "airwallex.com/hudled" }))] })) })) }))] }));
};
exports.default = ForexCosts;
